import { FirebaseTimestampType } from 'firebase/index'
import { useMemo } from 'react'
import { addMonths, startOfMonth, differenceInMonths } from 'date-fns'

const useReportedMonths = (createdAt: FirebaseTimestampType | undefined): Date[] => {
  return useMemo(() => {
    if (!createdAt) return []
    const createdDate = createdAt.toDate()
    const firstReportedMonth = startOfMonth(createdDate)
    const thisMonth = startOfMonth(new Date())
    const diff = differenceInMonths(thisMonth, firstReportedMonth)
    if (diff <= 0) return []
    return [...Array(diff)]
      .map((_, i) => addMonths(firstReportedMonth, i))
      .sort((a, b) => (a.getTime() > b.getTime() ? -1 : 1))
  }, [createdAt])
}

export default useReportedMonths
